import { TruckTelematicsDto } from '../../../services/truck.services';
import { TrackingLatLng } from './orderTracking.interface';

/**
 * Keeps the GPS points recorded inside `[from, to]` (epoch ms, both optional).
 * Without per-point times the trail cannot be cut, so nothing is kept.
 */
export const trailWithin = (
	telematics: TruckTelematicsDto | undefined,
	from?: number,
	to?: number,
): TruckTelematicsDto | undefined => {
	if (!telematics) return telematics;
	const trail = telematics.trail ?? [];
	const times = telematics.trailAt;
	if (!times || times.length !== trail.length) {
		return { ...telematics, trail: [], trailAt: [] };
	}
	const keep = times.map(
		(at) =>
			(from === undefined || at >= from) && (to === undefined || at <= to),
	);
	return {
		...telematics,
		trail: trail.filter((_, index) => keep[index]),
		trailAt: times.filter((_, index) => keep[index]),
	};
};

/** The path the truck actually drove (deadhead → pickup → delivery). */
export const drivenPath = (
	telematics: TruckTelematicsDto | undefined,
): TrackingLatLng[] => {
	const points: TrackingLatLng[] = [];
	(telematics?.trail ?? []).forEach((item) => {
		if (
			Array.isArray(item) &&
			Number.isFinite(item[0]) &&
			Number.isFinite(item[1])
		) {
			points.push({ lat: item[0], lng: item[1] });
		}
	});
	return points.length < 2 ? [] : points;
};
